module.exports = __webpack_public_path__ + "static/FrankensteinPromo-38-ff70f6ff780c3faf6fe47c7aee0d9cd2.jpg";